import {getMsgList, cancelSendMsg} from 'crm/services/group-msg'
import {parse} from 'qs'
import createModel from 'utils/model'

const params = {
    keyword: undefined,
    user_id: undefined,
    create_time_from: undefined,
    create_time_to: undefined,
    execute_time_from: undefined,
    execute_time_to: undefined,
    limit: 10,
    offset: 0,
}

export default createModel({
    namespace: 'crm_groupMsg',

    state: {
        params: {
            ...params,
        },
        list: [],
        total: 0,
        current: 1,
    },

    effects: {
        *getMsgList({payload, callback}, {select, call, put}) {
            // eslint-disable-next-line no-shadow
            let params = yield select(({crm_groupMsg}) => crm_groupMsg.params)
            params = {...params, ...payload.params}
            if (payload.page) {
                params.offset = params.limit * (payload.page - 1)
            }

            const data = yield call(getMsgList, {params: parse(params)})

            if (data && data.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        list: data.data,
                        params,
                        total: data.pagination.rows_found,
                        current: payload.page === undefined ? 1 : payload.page,
                    },
                })
                callback && callback(data.data)
            }
        },

        *cancelSendMsg({payload}, {call}) {
            return yield call(cancelSendMsg, payload)
        },
    },

    reducers: {
        resetParams(state) {
            return {...state, params}
        },
    },
})
